import { createSlice } from "@reduxjs/toolkit";
import { TermResponseDto } from "../../shared/dtos/term/TermResponseDto";
import {
  getInitialCrudState,
  generateCrudReducers,
} from "../utils/crudFactory";

export const termSlice = createSlice({
  name: "term",
  initialState: getInitialCrudState<TermResponseDto>(),
  reducers: {
    ...generateCrudReducers<TermResponseDto>(),
  },
});

export const termActions = termSlice.actions;
export default termSlice.reducer;
